module.exports = __webpack_public_path__ + "static/logo-ecologi-colour-3cfba4a0e2046aed987667191fb50d63.png";